import { FREE_MEETING_MAX_DURATION_SECONDS } from '../../../utils/plan.ts';

export const LIVE_MEETING_MAX_DURATION_MS = FREE_MEETING_MAX_DURATION_SECONDS * 1000;

export interface LiveMeetingTiming {
  status?: string;
  startedAt?: string | null;
  createdAt?: string;
}

export function getLiveSessionStartedAt(meeting: LiveMeetingTiming): number | null {
  const started = meeting.startedAt ?? meeting.createdAt;
  if (!started) return null;
  return new Date(started).getTime();
}

export function isLiveSessionExpired(meeting: LiveMeetingTiming, now = Date.now()): boolean {
  if (meeting.status !== 'LIVE') return false;

  const startedAt = getLiveSessionStartedAt(meeting);
  if (startedAt === null) return true;

  return now - startedAt >= LIVE_MEETING_MAX_DURATION_MS;
}

/** DB'de LIVE olsa bile süre dolmuşsa canlı sayılmaz. */
export function isMeetingLiveActive(meeting: LiveMeetingTiming, now = Date.now()): boolean {
  return meeting.status === 'LIVE' && !isLiveSessionExpired(meeting, now);
}

export function getLiveSessionRemainingMs(meeting: LiveMeetingTiming, now = Date.now()): number {
  if (!isMeetingLiveActive(meeting, now)) return 0;
  const startedAt = getLiveSessionStartedAt(meeting);
  if (startedAt === null) return 0;
  return Math.max(0, LIVE_MEETING_MAX_DURATION_MS - (now - startedAt));
}
